import activities from './activities'
import dai from './dai'
import auditProcess from './auditProcess'
import audits from './audits'
import auth from './auth'
import avatarLetters from './avatarLetters'
import baseStatusCard from './baseStatusCard'
import cardFlag from './cardFlag'
import changeCase from './changeCase'
import company from './company'
import companyFreeTrials from './companyFreeTrials'
import companySuppliers from './companySuppliers'
import companyTrails from './companyTrails'
import complaint from './complaint'
import consent from './consent'
import contentHeader from './contentHeader'
import cookies from './cookies'
import services from './services'
import dataCollected from './dataCollected'
import dataIntelligence from './dataIntelligence'
import dataLifeCycle from './dataLifeCycle'
import dataProcess from './dataProcesses'
import dataTreatment from './dataTreatment'
import dataTreatmentAgent from './dataTreatmentAgent'
import departments from './departments'
import diffViewer from './diffViewer'
import documentVersion from './documentVersion'
import driverJs from './driverJs'
import file from './file'
import form from './form'
import formatters from './formatters'
import fragilities from './fragilities'
import fragilityEntities from './fragilityEntities'
import functions from './functions'
import governanceProject from './governanceProject'
import guestPortal from './guestPortal'
import incidents from './incidents'
import inviteAdvisor from './inviteAdvisor'
import leaflet from './leaflet'
import logs from './logs'
import marketplace from './marketplace'
import microsoftLogin from './microsoftLogin'
import mixpanel from './mixpanel'
import multiSelect from './multiSelect'
import myLgpd from './myLgpd'
import necessityAndProportionality from './necessityAndProportionality'
import nonComplianceReports from './nonComplianceReports'
import orders from './orders'
import palette from './palette'
import partners from './partners'
import plans from './plans'
import preRegistration from './preRegistrations'
import privacyByDesign from './privacyByDesign'
import privacyPolicies from './privacyPolicies'
import questionControls from './questionControls'
import questionnaires from './questionnaires'
import questions from './questions'
import recurrence from './recurrence'
import regex from './regex'
import regulations from './regulations'
import reports from './reports'
import ripds from './ripds'
import settings from './settings'
import suggestedChanges from './suggestedChanges'
import supplierInvite from './supplierInvite'
import suppliers from './suppliers'
import tags from './tags'
import thirdPartyManegementPartners from './thirdPartyManegementPartners'
import tickets from './tickets'
import user from './user'
import userSteps from './userSteps'
import userTrailSteps from './userTrailSteps'
import truncateUIText from './truncateUIText'
import validates from './validates'
import whiteLabel from './whiteLabel'

const helpers = {
  activities,
  dai,
  auditProcess,
  audits,
  auth,
  avatarLetters,
  baseStatusCard,
  cardFlag,
  changeCase,
  company,
  companyFreeTrials,
  companySuppliers,
  companyTrails,
  complaint,
  consent,
  contentHeader,
  cookies,
  services,
  dataCollected,
  dataIntelligence,
  dataLifeCycle,
  dataProcess,
  dataTreatment,
  dataTreatmentAgent,
  departments,
  diffViewer,
  documentVersion,
  driverJs,
  file,
  form,
  formatters,
  fragilities,
  fragilityEntities,
  functions,
  governanceProject,
  guestPortal,
  incidents,
  inviteAdvisor,
  leaflet,
  logs,
  marketplace,
  microsoftLogin,
  mixpanel,
  multiSelect,
  myLgpd,
  necessityAndProportionality,
  nonComplianceReports,
  orders,
  palette,
  partners,
  plans,
  preRegistration,
  privacyByDesign,
  privacyPolicies,
  questionControls,
  questionnaires,
  questions,
  recurrence,
  regex,
  regulations,
  reports,
  ripds,
  settings,
  suggestedChanges,
  supplierInvite,
  suppliers,
  tags,
  thirdPartyManegementPartners,
  tickets,
  truncateUIText,
  user,
  userSteps,
  userTrailSteps,
  validates,
  whiteLabel,
}

export default helpers
